/**
 * Navbar Component - WorkStream
 * Navegação reutilizável para o marketing site
 */
import { useState } from 'react'
import { Menu, X, Zap, ChevronRight } from 'lucide-react'

interface NavbarProps {
  transparent?: boolean
}

export default function Navbar({ transparent = false }: NavbarProps) {
  const [isOpen, setIsOpen] = useState(false)

  const navItems = [
    { label: 'Início', href: '/' },
    { label: 'Serviços', href: '/#services' },
    { label: 'Planos', href: '/#pricing' },
    { label: 'Clientes', href: '/#testimonials' },
    { label: 'Contato', href: '/#contact' },
  ]

  return (
    <nav
      className={`sticky top-0 z-50 border-b ${
        transparent 
          ? 'bg-transparent border-transparent' 
          : 'bg-[#0B1120]/80 backdrop-blur-xl border-slate-800'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <a href="/" className="flex items-center gap-3 group">
            <div 
              className="w-9 h-9 rounded-xl flex items-center justify-center shadow-lg shadow-cyan-500/20 group-hover:shadow-cyan-500/40 transition-all"
              style={{ background: 'linear-gradient(135deg, #00C6FF 0%, #0072FF 100%)' }}
            >
              <Zap className="w-5 h-5 text-white" />
            </div>
            <span className="text-xl font-black text-white">
              Work<span className="font-light italic text-cyan-400">Stream</span>
            </span>
          </a>

          {/* Desktop Menu */}
          <div className="hidden md:flex gap-8">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="text-slate-400 hover:text-white transition-colors text-sm font-medium"
              >
                {item.label}
              </a>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="hidden md:flex items-center gap-3">
            <a
              href="https://app.workstream.com.br/auth/login"
              className="px-4 py-2 text-slate-400 hover:text-white transition-colors text-sm font-medium"
            >
              Login
            </a>
            <a
              href="https://app.workstream.com.br/auth/signup"
              className="px-5 py-2 rounded-xl text-white text-sm font-semibold flex items-center gap-1 transition-all hover:-translate-y-0.5"
              style={{ 
                background: 'linear-gradient(135deg, #00C6FF 0%, #0072FF 100%)',
                boxShadow: '0 4px 14px 0 rgba(0, 198, 255, 0.39)'
              }}
            >
              Começar Grátis
              <ChevronRight className="w-4 h-4" />
            </a>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 text-slate-400 hover:text-white rounded-lg hover:bg-slate-800"
            aria-label="Toggle menu"
          >
            {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden py-4 space-y-2 border-t border-slate-800">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="block px-4 py-2 text-slate-400 hover:text-white hover:bg-slate-800/50 rounded-lg transition-colors"
                onClick={() => setIsOpen(false)}
              >
                {item.label}
              </a>
            ))}
            <div className="pt-4 px-4 space-y-2">
              <a
                href="https://app.workstream.com.br/auth/login"
                className="block py-2 text-center text-slate-400 hover:text-white transition-colors"
              >
                Login
              </a>
              <a
                href="https://app.workstream.com.br/auth/signup"
                className="block py-3 text-center rounded-xl text-white font-semibold"
                style={{ 
                  background: 'linear-gradient(135deg, #00C6FF 0%, #0072FF 100%)',
                }}
              >
                Começar Grátis
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  )
}
